export function deepReplaceValues<T>(
  obj: T,
  replacements: Map<any, any>
): T {
  if (replacements.has(obj)) {
    return replacements.get(obj) as T;
  } else if (
    !replacements.size
    || typeof obj !== 'object'
    || obj == null
  ) {
    return obj;
  } else if (Array.isArray(obj)) {
    return obj.map((element) => deepReplaceValues(element, replacements)) as T;
  }

  const newObj = { ...obj };
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[key] = deepReplaceValues(obj[key], replacements);
    }
  }

  return newObj;
}
